import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/main-content/router-test/index.vue'
import Form from '@/components/main-content/form.vue'
import Layout from '@/components/main-content/layout.vue'
import Container from '@/components/main-content/container.vue'
import Icon from '@/components/main-content/icon.vue'
import Upload from '@/components/main-content/upload-file.vue'
import StarTagProgress from '@/components/main-content/star-tag-progress.vue'
import ColorPickerTree from '@/components/main-content/colorPicker-tree.vue'
import Editor from '@/components/main-content/editor.vue'
import Transfer from '@/components/main-content/transfer.vue'
import Table from '@/components/main-content/table.vue'
import Message from '@/components/main-content/message.vue'
import CardCarouselCollapse from '@/components/main-content/card-carousel-collapse.vue'
import TransferValue from '@/components/main-content/transfer-value/index.vue'
import VueForm from '@/components/main-content/vue-form.vue'
import VueSlot from '@/components/main-content/slot/vue-slot.vue'
import VueLazyload from '@/components/main-content/v-lazy.vue'
import VueCropper from '@/components/main-content/VueCropper.vue'
import MapTem from '@/components/main-content/map/map-tem.vue'
import VueScrollbar from '@/components/main-content/vue-scrollbar.vue'
import VueScroller from '@/components/main-content/vue-scroller.vue'
import VueAwesomeSwiper from '@/components/main-content/vue-awesome-swiper.vue'
import LoadingModel from '@/components/main-content/loading-model.vue'
import VueBaiduMap from '@/components/main-content/vue-baidu-map/vue-baidu-map.vue'
import Svg from '@/components/main-content/svg/svg.vue'
import svg1 from '@/components/main-content/svg/svg1.vue'
import Color from '@/components/main-content/color.vue'
import MonacoEditor from '@/components/main-content/monaco-editor/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'login',
      path: '/login',
      redirect: '/',//重定向到这个地址
      meta:{
        fullScreen:true,
      }
    },
    {
      name: 'index',
      path: '/home',
      redirect: '/home/indexN',//重定向到这个地址
      component: Index,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/router-test/index.vue'),
      children: [//嵌套路由
        {
          path: 'indexN',
          name: 'indexN',
          component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/router-test/indexN.vue'),
          // component: indexN
        },
        {
          path: 'index1/:id',//路由传id值 通过this.$route.params获取值对象 路由传值1
          name: 'index1',
          // component: Index1
          component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/router-test/index1.vue'),
        },
        {
          path:'index2/:id',
          name:'index2',
          // component:Index2
          component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/router-test/index2.vue'),
        },
        /*{
          path:'/online',
          component:Online
        }*/
      ]
    },
    {
      path: '/home',
      name: 'index',
      component: Index,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/router-test/index.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/form',
      name: 'form',
      component: Form,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/form.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/layout',
      name: 'Layout',
      component: Layout,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/layout.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/container',
      name: 'Container',
      component: Container,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/container.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/icon',
      name: 'Icon',
      component: Icon,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/icon.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/upload-file.vue'),
      component: Upload,
      meta:{
        keepAlive:true,
      }
    },
    {
      path: '/star-tag-progress',
      name: 'Star-tag-progress',
      component: StarTagProgress,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/star-tag-progress.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/colorPicker-tree',
      name:'ColorPickerTree',
      component: ColorPickerTree,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/colorPicker-tree.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/editor',
      name:'Editor',
      component: Editor,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/editor.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/transfer',
      name:'Transfer',
      component: Transfer,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/transfer.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/table',
      name:'Table',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/table.vue'),
      component: Table,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/message',
      name:'Message',
      component: Message,
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/message.vue'),
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/card-carousel-collapse',
      name:'CardCarouselCollapse',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/card-carousel-collapse.vue'),
      component: CardCarouselCollapse,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/transfer-value',
      name:'TransferValue',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/transfer-value/index.vue'),
      component: TransferValue,
      meta:{
        keepAlive:true,
      }
    },
    /*{
      path:'/map',
      name:'Map',
      component: MapTem
    },*/
    {
      path:'/vue-form',
      name:'VueForm',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/vue-form.vue'),
      component: VueForm,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-slot',
      name:'VueSlot',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/slot/vue-slot.vue'),
      component: VueSlot,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-lazyload',
      name:'VueLazyload',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/v-lazy.vue'),
      component: VueLazyload,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-cropper',
      name:'VueCropper',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/VueCropper.vue'),
      component: VueCropper,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-scrollbar',
      name:'VueScrollbar',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/vue-scrollbar.vue'),
      component: VueScrollbar,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-scroller',
      name:'VueScroller',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/vue-scroller.vue'),
      component: VueScroller,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-awesome-swiper',
      name:'VueAwesomeSwiper',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/vue-awesome-swiper.vue'),
      component: VueAwesomeSwiper,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/loading-model',
      name:'LoadingModel',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/loading-model.vue'),
      component: LoadingModel,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/vue-baidu-map',
      name:'VueBaiduMap',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/vue-baidu-map/vue-baidu-map.vue'),
      component: VueBaiduMap,
      meta:{
        keepAlive:true,
      }
    },
    {
      path:'/svg',
      name:'svg',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/svg/svg.vue'),
      component: Svg,
      meta:{
        keepAlive:true,
      }
    },
    /*{
      name: 'svg',
      path: '/svg',
      component: svg,
      children: [//嵌套路由
        {
          path: 'svg1',
          name: 'svg1',
          component: svg1
        },
      ]
    },*/
    {
      path:'/color',
      name:'color',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/svg/svg.vue'),
      component: Color,
    },
    {
      path:'/monaco-editor',
      name:'monaco-editor',
      // component: () => import(/* webpackChunkName: "about" */ '@/components/main-content/svg/svg.vue'),
      component: MonacoEditor,
    },
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js